<template>
    <tbody>
        <tr>
            <td>
                <tr>
                    <td class="no-border-and-padding">
                        <input autocomplete="off" v-model="innerPeriod.startOfPeriod"
                            name="startOfPeriod"
                            disabled>
                    </td>
                    <td class="no-border-and-padding td-icon-space"  v-if="retirementDate !== '' && innerPeriod.startOfPeriod === retirementDate">
                        <icon-tooltip tooltip-name="identifier" tooltip-text="This period has been split automatically at the age at which this person retires. You can still change this manually." side="right" text-width="300" icon-type="info"></icon-tooltip>
                    </td>
                </tr>
            </td>
            <td>
                <date-input v-model="innerPeriod.endOfPeriod"
                            v-field-control.required="{type:'date', name:'endOfPeriod' + index}"
                            :emit="true"
                            @input="updateNextPeriod()"
                ></date-input>
            </td>
            <td v-if="!retired">
                <select v-model="innerPeriod.employmentType" @change="updatePeriod()">
                    <option value="employed">Employed</option>
                    <option value="self_employed">Self-employed</option>
                    <option value="part_employed">Part-employed</option>
                    <option value="not_employed">Not employed</option>
                </select>
            </td>
            <td v-if="!retired">
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" min="0" v-model.number="innerPeriod.employmentIncome"
                           v-field-control.required="{type:'number', name:'employmentIncome' + index}"
                           v-on:focus="innerPeriod.employmentIncome = innerPeriod.employmentIncome || ''"
                           v-on:blur="innerPeriod.employmentIncome = innerPeriod.employmentIncome || 0"
                           v-two-dp
                           @input="updatePeriod()">
                </div>
            </td>
            <td v-if="!retired">
                <select v-model="innerPeriod.employmentNetGross" @change="updatePeriod()">
                    <option value="net">Net</option>
                    <option value="gross">Gross</option>
                </select>
            </td>
            <td>
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" min="0" v-model.number="innerPeriod.pensionIncome"
                           v-field-control.required="{type:'number', name:'pensionIncome' + index}"
                           v-on:focus="innerPeriod.pensionIncome = innerPeriod.pensionIncome || ''"
                           v-on:blur="innerPeriod.pensionIncome = innerPeriod.pensionIncome || 0"
                           v-two-dp
                           @input="updatePeriod()">
                </div>
            </td>
            <td>
                <select v-model="innerPeriod.pensionNetGross" @change="updatePeriod()">
                    <option value="net">Net</option>
                    <option value="gross">Gross</option>
                </select>
            </td>
            <td v-if="!retired ">
                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" v-model.number="innerPeriod.totalGrossIncome" v-two-dp disabled>
                </div>
            </td>
            <td>

                <div class="a-form-inputs--pound">
                    <input autocomplete="off" type="number" v-model.number="innerPeriod.totalNetIncome" v-two-dp disabled>
                </div>
            </td>
            <td v-if="this.index === 0">
                <div :class="{ 'a-loader--total' : loading }"></div>
                <button v-if="!loading" class="a-button a-button--delete a-button--delete-disabled a-button--small" role="button" type="button" disabled="disabled"></button>
            </td>
            <td v-else>
                <div :class="{ 'a-loader--total' : loading }"></div>
                <button v-if="!loading" class="a-button a-button--delete a-button--small" role="button" type="button" @click="deletePeriod"></button>
            </td>
        </tr>
        <tr class="a-table--error" v-if="!endOfPeriodRules">
            <td :colspan="!retired ? 10 : 6">
                <control-error>
                    The income period end date can not be before the deceased's date of death and
                    cannot be after the deceased's 'but for' date of death
                </control-error>
            </td>
        </tr>
        <tr class="a-table--error" v-if="retired && !incomeRules && this.dependant === null">
            <td colspan="6">
                <control-error>
                    The Pension Income must be greater than &pound;0.00
                </control-error>
            </td>
        </tr>
        <tr class="a-table--error" v-if="!retired && !incomeRules && this.dependant === null">
            <td colspan="10">
                <control-error>
                    The Pension Income OR Employment Income must be greater than &pound;0.00
                </control-error>
            </td>
        </tr>
        <tr class="a-table--error" v-if="!endValid">
            <td colspan="10">
                <control-error>
                    The end date of a period must be at least one day after the start.
                </control-error>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import _ from 'lodash';
    import moment from 'moment';
    import {mapActions, mapGetters} from 'vuex';
    import DateInput from 'components/form/control/DateInput.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import IconTooltip from 'components/IconTooltip.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import IncomePeriodMix from 'pages/fatal-accident-claims/dependency/steps/dependency-on-income/income-period.mixin';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    export default {
        name: 'income-period',
        components: {
            DateInput,
            Control,
            ControlError,
            IconTooltip
        },
        props: {
            retired: {
                type: Boolean,
                default: false
            },
            retirementDate: {
                default: "",
            },
            index: {
                type: Number,
                default: 0
            },
            maxIndex: {
                type: Number,
                default: 0
            }
        },
        mixins: [
            currencyFormat,
            IncomePeriodMix,
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('fatal/dependency/deceased', [
                'theDeceased',
                'getDeceasedIncomePeriod',
                'getDeceasedIncomeStatus'
            ]),
            ...mapGetters('fatal/dependency/dependants', {
                findDependant: 'theDependant',
                getNoOfDependantPeriods: 'getNoOfDependantPeriods',
                getDependantIncomePeriod: 'getDependantIncomePeriod',
                getDependantIncomeStatus: 'getDependantIncomeStatus',
            }),
            loading: {
                get() {
                    return this.getDeceasedIncomeStatus || this.getDependantIncomeStatus
                }
            },
            endOfPeriodRules() {
                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY'))) {
                    return false;
                }
                if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.theDeceased.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY'))) {
                    return false;
                }
                return true;
            },
            incomeRules() {
                if (this.retired) {
                    return this.innerPeriod.pensionIncome < 1 ? false : true;
                }

                return this.innerPeriod.employmentIncome < 1 && this.innerPeriod.pensionIncome < 1 ? false : true;
            },
            endValid() {
                return moment(this.innerPeriod.startOfPeriod,'DD/MM/YYYY')
                    .isBefore(
                        moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY')
                    );
            }
        },
        methods: {
            ...mapActions('fatal/dependency/deceased', [
                'addDeceasedIncomePeriod',
                'updateDeceasedIncomePeriodValue',
                'deleteDeceasedIncomePeriod',
            ]),
            ...mapActions('fatal/dependency/dependants', [
                'addDependantIncomePeriod',
                'updateDependantIncomePeriodValue',
                'deleteDependantIncomePeriod',
            ]),
            updatePeriod() {
                this.$emit('update', {index: this.index, period: this.innerPeriod, dependant: this.findDependant(this.dependant), deceased: this.theDeceased, dependantIndex: this.dependant});
            },
            deletePeriod(){
                let maxIndex = this.maxIndex - 1;

                if (this.dependant === null) {
                    let prevIndex = this.index - 1;
                    let nextIndex = this.index + 1;
                    let nextPeriodEndOfPeriod = this.getDeceasedIncomePeriod(prevIndex).endOfPeriod;
                    let nextDay = moment(nextPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                    if (this.index === maxIndex) {
                        this.updateDeceasedIncomePeriodValue({index: prevIndex, key: 'endOfPeriod', value: this.theDeceased.lifeExpectancy.dateOfDeath});
                    } else {
                        this.updateDeceasedIncomePeriodValue({index: nextIndex, key: 'startOfPeriod', value: nextDay});
                    }
                    this.deleteDeceasedIncomePeriod({index: this.index});
                } else {
                    let prevIndex = this.index - 1;
                    let nextIndex = this.index + 1;
                    let prevPeriodEndOfPeriod = this.getDependantIncomePeriod(this.dependant,prevIndex).endOfPeriod;
                    let nextDay = moment(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                    if (this.index === maxIndex) {
                        this.updateDependantIncomePeriodValue({index: prevIndex, key: 'endOfPeriod', value: this.theDeceased.lifeExpectancy.dateOfDeath, dependant: this.findDependant(this.dependant), dependantIndex: this.dependant});
                    } else {
                        this.updateDependantIncomePeriodValue({index: nextIndex, key: 'startOfPeriod', value: nextDay, dependant: this.findDependant(this.dependant), dependantIndex: this.dependant});
                    }

                    this.deleteDependantIncomePeriod({index: this.index, dependant: this.findDependant(this.dependant), dependantIndex: this.dependant});
                }
            },
            updateNextPeriod() {
                let maxIndex = this.maxIndex - 1;
                let dependantMaxIndex = null;

                this.updatePeriod();

                if (!this.endValid) {
                    return;
                }
                // Do not look at the below, it's a mess

                if (this.index < maxIndex) {

                    let nextIndex = this.index + 1;
                    let nextDay = moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');

                    (this.dependant === null) ?
                        this.updateDeceasedIncomePeriodValue({
                            index: nextIndex,
                            key: 'startOfPeriod',
                            value: nextDay
                        }) :
                        this.updateDependantIncomePeriodValue({
                            index: nextIndex,
                            key: 'startOfPeriod',
                            value: nextDay,
                            dependant: this.findDependant(this.dependant),
                            dependantIndex: this.dependant
                        });

                    for (let i = nextIndex, len = maxIndex; i <= len; i++) {

                        let prevPeriodEndOfPeriod = '';
                        let periodEndOfPeriod = '';
                        let periodStartOfPeriod = '';

                        if (this.dependant === null) {
                            prevPeriodEndOfPeriod = this.getDeceasedIncomePeriod(i - 1).endOfPeriod;
                            periodEndOfPeriod = this.getDeceasedIncomePeriod(i).endOfPeriod;
                            periodStartOfPeriod = this.getDeceasedIncomePeriod(i).startOfPeriod;
                        } else {
                            prevPeriodEndOfPeriod = this.getDependantIncomePeriod(this.dependant, i - 1).endOfPeriod;
                            periodEndOfPeriod = this.getDependantIncomePeriod(this.dependant, i).endOfPeriod;
                            periodStartOfPeriod = this.getDependantIncomePeriod(this.dependant, i).startOfPeriod;
                        }


                        if (prevPeriodEndOfPeriod > periodStartOfPeriod) {
                            periodStartOfPeriod = moment(prevPeriodEndOfPeriod, 'DD/MM/YYYY').format('DD/MM/YYYY');
                            (this.dependant === null) ?
                                this.updateDeceasedIncomePeriodValue({
                                    index: i,
                                    key: 'startOfPeriod',
                                    value: periodStartOfPeriod
                                }) :
                                this.updateDependantIncomePeriodValue({
                                    index: i,
                                    key: 'startOfPeriod',
                                    value: periodStartOfPeriod,
                                    dependant: this.findDependant(this.dependant),
                                    dependantIndex: this.dependant
                                })

                        }

                        if (periodEndOfPeriod <= periodStartOfPeriod && i !== len) {
                            (this.dependant === null) ?
                                this.updateDeceasedIncomePeriodValue({
                                    index: i,
                                    key: 'endOfPeriod',
                                    value: periodStartOfPeriod
                                }) :
                                this.updateDependantIncomePeriodValue({
                                    index: i,
                                    key: 'endOfPeriod',
                                    value: periodStartOfPeriod,
                                    dependant: this.findDependant(this.dependant),
                                    dependantIndex: this.dependant
                                })
                        }
                    }
                }

                if (this.dependant !== null) {
                    dependantMaxIndex = this.getNoOfDependantPeriods(this.dependant) - 1;
                }

                if (this.dependant === null) {
                    if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.theDeceased.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY'))
                        && moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY'))
                        && this.index === maxIndex) {
                        this.addDeceasedIncomePeriod();
                    }
                } else if (moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isBefore(moment(this.theDeceased.lifeExpectancy.dateOfDeath, 'DD/MM/YYYY'))
                    && moment(this.innerPeriod.endOfPeriod, 'DD/MM/YYYY').isAfter(moment(this.theDeceased.dateOfDeath, 'DD/MM/YYYY'))
                    && this.index === dependantMaxIndex) {
                    this.addDependantIncomePeriod({index: this.dependant});
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// IncomePeriod.vue?076df11d